export default class Debugger {

    /**
     *
     * @type {Debugger}
     * @memberof Debugger
     */
    static _instance;

    isShowLog = false;

    showTag = "";


    /**
     *
     *
     * @readonly
     * @memberof Debugger
     */
    static get Instance() {
        if (this._instance == null) {
            this._instance = new Debugger();
            window.debugger = this._instance;
        }

        return this._instance;
    }


    /**
     *
     * 開啟console
     * @param {string} [tag=""] 要顯示的tag
     * @memberof Debugger
     */
    showLog(tag = "") {
        this.isShowLog = true;
        this.showTag = tag;
    }

    /**
     *
     * console.log 改寫
     * @param {object} msg 請用object或是一個string
     * @param {string} tag tag
     * @param {string} [type="log"] log | error
     * @memberof Debugger
     */
    log(msg, tag, type = "log") {
        if (!this.isShowLog) return;
        if (this.showTag != "" && this.showTag != tag) return;
        switch (type) {
            case "log":
                console.log(tag, msg);
                break;
            case "error":
                console.error(tag, msg);
                break;
        }
    }

    error(tag, ...msg) {
        console.error(tag, msg);
    }
}

